export const GET_QUESTIONS_PER_TYPE_REQUEST = "GET_QUESTIONS_PER_TYPE_REQUEST";
export const GET_QUESTIONS_PER_TYPE_SUCCESS = "GET_QUESTIONS_PER_TYPE_SUCCESS";
export const GET_QUESTIONS_PER_TYPE_FAILURE = "GET_QUESTIONS_PER_TYPE_FAILURE";
